module.exports = __webpack_public_path__ + "static/img/HONDA.a437a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/HONDA.png
// module id = qqTp
// module chunks = 1